









































import Vue from "vue";
import StandartCard from "@/components/Card/StandartCard/StandartCard.vue";
import Paragraph from "@/components/Text/Global/Paragraph.vue";
import { store } from "@/store/store";
import { DeviceFilters } from "@/types/types";
import { mapState } from "vuex";

interface DeviceInformationsStatus {
  name: string;
  color: string;
  status: Float32Array | number;
  count: number;
}

interface DeviceStatusCardData {
  device_status: Array<DeviceInformationsStatus>;
}

export default Vue.extend({
  name: "DeviceStateCard",
  components: { StandartCard, Paragraph },
  props: {
    filters: {
      type: Object as () => DeviceFilters
    }
  },
  data(): DeviceStatusCardData {
    return {
      device_status: []
    };
  },
  mounted(): void {
    this.countDeviceStatus();
    this.calculatePourcentage();
    this.sortDeviceResult();
  },
  methods: {
    countDeviceStatus(): void {
      this.device_status = [];
      store.getters.DEVICE_ALL_ID.forEach((device_id) => {
        let device_state: string = store.getters.DEVICE_BY_ID[device_id].state;
        let state_name: string = store.getters.STATE_BY_ID[device_state].name;
        let device_status = this.device_status.find((status) => status.name === state_name);
        if (device_status) device_status.count += 1;
        else
          this.device_status.push({
            name: state_name,
            status: 0,
            count: 1,
            color: store.getters.STATE_BY_ID[device_state].color
          });
      });
    },
    calculatePourcentage(): void {
      const device_len = store.getters.DEVICE_ALL_ID.length;
      this.device_status.forEach((device_status) => {
        device_status.status = (device_status.count / device_len) * 100;
      });
    },
    sortDeviceResult(): void {
      this.device_status.sort(
        (a: DeviceInformationsStatus, b: DeviceInformationsStatus) => (b.status as number) - (a.status as number)
      );
    },
    onChange(state: string): void {
      this.$emit("onFilterChange", {
        type: "state",
        value: state === this.filters.state ? "" : state
      });
    }
  },
  computed: mapState({
    view(): string | null {
      return this.$store.state.view;
    }
  }),
  watch: {
    view: {
      handler(): void {
        this.countDeviceStatus();
        this.calculatePourcentage();
        this.sortDeviceResult();
      }
    }
  }
});
